/*
  omega copy pasted from loading.io 
  https://loading.io/css/
*/
/* eslint-disable */
import "./style.css";

export default ({ className = "" }) => (
  <div className={`lds-ellipsis ${className}`}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);
